import { NavLink, Outlet } from "react-router-dom";
import {
  Building2,
  Users,
  BookOpen,
  Hammer,
  Mail,
  Receipt,
  Inbox,
  Radio,
  Bug,
  Zap,
  ShieldAlert,
} from "lucide-react";

const SECTIONS = [
  { to: "/settings/company", label: "Entreprise", icon: Building2 },
  { to: "/settings/integrations", label: "Intégrations", icon: Zap },
  { to: "/settings/team", label: "Équipe", icon: Users },
  { to: "/settings/lead-sources", label: "Sources de leads", icon: Radio },
  { to: "/settings/webhooks-log", label: "Journal webhook", icon: Bug },
  { to: "/settings/catalog", label: "Catalogue", icon: BookOpen },
  { to: "/settings/chantier-types", label: "Types de chantier", icon: Hammer },
  { to: "/settings/email", label: "Emails", icon: Mail },
  { to: "/settings/invoicing", label: "Facturation & Paiements", icon: Receipt },
  { to: "/settings/peppol", label: "Facturation électronique (Peppol)", icon: Zap },
  { to: "/settings/email-log", label: "Journal des emails", icon: Inbox },
  // Section Administration — outils admin transverses (audits, migrations).
  { separator: true, label: "Administration" },
  { to: "/admin/audit", label: "Audit rétroactif TVA", icon: ShieldAlert },
  { to: "/admin/dedup", label: "Déduplication catalogue", icon: ShieldAlert },
  { to: "/admin/env-check", label: "Vérification variables env", icon: ShieldAlert },
];

export default function SettingsLayout() {
  return (
    <div className="flex flex-col gap-6 lg:flex-row" data-testid="settings-layout">
      <aside className="w-full shrink-0 lg:w-56">
        <h2 className="mb-3 px-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
          Paramètres
        </h2>
        <nav className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible">
          {SECTIONS.map((s, i) => {
            if (s.separator) {
              return (
                <div
                  key={`sep-${i}`}
                  className="hidden lg:block pt-3 pb-1 px-2 text-[10px] font-semibold uppercase tracking-wider text-slate-600 border-t border-slate-800 mt-2"
                >
                  {s.label}
                </div>
              );
            }
            return (
              <NavLink
                key={s.to}
                to={s.to}
                className={({ isActive }) =>
                  `flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-[#C4553B]/15 text-[#C4553B] font-medium"
                      : "text-slate-300 hover:bg-slate-800/60"
                  }`
                }
                data-testid={`settings-nav-${s.to.split("/").pop()}`}
              >
                <s.icon className="h-4 w-4" />
                <span className="whitespace-nowrap">{s.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
